import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  active: css``,
};
export const components = {
  tab: css``,
};

export const tabs = css`
  display: flex;
  border-bottom: 1px solid ${theme.colors.peoople['gris-claro']};

  & .${components.tab} {
    white-space: nowrap;
    padding: 0.5rem 1rem;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    margin-bottom: -1px;

    &.${variants.active} {
      color: ${theme.colors.peoople['gris-oscuro']};
      font-weight: 700;
      position: relative;
      &::after {
        content: ' ';
        position: absolute;
        bottom: 4px;
        height: 2px;
        width: 50%;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${theme.colors.peoople['gris-oscuro']};
      }
      &:hover {
        color: ${theme.colors.peoople['gris-oscuro']};
      }
    }

    color: ${theme.colors.neutral['50']};
    background: transparent;
    display: inline-flex;
    gap: 16px;
    align-items: center;
    font-size: 16px;
    line-height: 20px;
    &:hover {
      color: ${theme.colors.peoople['gris-oscuro']};
    }
  }
`;
